import { render, staticRenderFns } from "./ExpandBlock.vue?vue&type=template&id=7fb5043d&scoped=true"
import script from "./ExpandBlock.vue?vue&type=script&lang=js"
export * from "./ExpandBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb5043d",
  null
  
)

export default component.exports